exports.lang = {
    "kr": "th",
    "아프리카TV | 투표" : "AfreecaTV | โหวต",
    "투표" : "โพล",
    "투표 등록" : "สร้างโพล",
    "투표 수정" : "แก้ไขโพล",
    "투표 등록 및 수정" : "สร้างและแก้ไขโพล",
    "종류" : "ประเภท",
    "기본형" : "ทั่วไป",
    "1:1 투표" : "2 ตัวเลือก",
    "제목" : "หัวข้อ",
    "투표 제목을 입력해주세요." : "กรุณาระบุหัวข้อ",
    "항목을 입력해주세요." : "กรุณาระบุตัวเลือก",
    "기간" : "ระยะเวลา",
    "투표 종료일" : "วันสิ้นสุดการโหวต",
    "종료일" : "วันสื้นสุดโพล",
    "설정" : "ตั้งค่า",
    "복수 선택 허용" : "เลือกได้หลายข้อ",
    "결과 미리보기 허용" : "ดูผลโหวตก่อนได้",
    "체크 박스를 해제하시면 투표에 참여하기 전 또는 투표가 종료될 때까지 모든 참여자가 투표 결과를 확인할 수 없습니다." : "หากท่านไม่เลือกหัวข้อนี้ ผู้โหวตจะไม่สามารถดูผลการโหวตก่อนได้",
    "수정" : "แก้ไข",
    "닫기" : "ปิด",
    "삭제" : "ลบ",
    "등록" : "สร้าง",
    "투표 항목을 입력해주세요." : "กรุณาระบุตัวเลือก",
    "투표 항목은 최소 2개 이상 등록해야 합니다." : "ต้องมีอย่างน้อย 2 ตัวเลือก",
    "투표는 최대 3개까지 등록할 수 있습니다." : "ท่านสามารถสร้างโพลได้ 3 โพล",
    "투표 항목은 최대 10개까지 만들 수 있습니다." : "ท่านสามารถกำหนดตัวเลือกได้ 10 ตัวเลือก",
    "투표 제목은 최대 30자까지 입력할 수 있습니다." : "สามารถใช้ตัวอักษรได้ 60 ตัวในการตั้งหัวข้อ",
    "투표 항목은 최대 10자까지 입력할 수 있습니다." : "สามารถใช้ตัวอักษรได้ 20 ตัวในการตั้งตัวเลือก",
    "올바른 파일 형식이 아닙니다.\n파일 확장명이 JPG, GIF 인지 다시 확인해주세요." : "ไม่สามารถใช้ประเภทไฟล์นี้ได้ กรุณาตรวจสอบประเภทไฟล์ของท่านว่าเป็น JPG หรือ GIF หรือไม่",
    "파일 용량이 10MB을(를) 초과하여 등록할 수 없습니다." : "ขนาดไฟล์ไม่สามารถเกิน 10MB ได้",
    "선택하신 GIF 파일 용량이 200KB를 초과하여 등록할 수 없습니다. 파일 용량을 다시 확인해주세요." : "ไม่สามารถใช้งานไฟล์ GIF ที่เลือกได้เนื่องจากมีขนาดเกิน 200KB กรุณาตรวจสอบขนาดไฟล์อีกครั้ง",
    "투표 기간을 설정해주세요." : "กรุณาตั้งระยะเวลาโหวต",
    "오늘보다 이전 날짜 또는 시간은 설정할 수 없습니다." : "ไม่สามารถตั้งเวลาก่อนเวลาปัจจุบันได้",
    "입력하신 내용이 모두 초기화됩니다. 투표 형식을 변경하시겠습니까?" : "ข้อมูลทั้งหมดจะถูกลบหากท่านต้องการเปลี่ยนแปลงรูปแบบการโหวต ท่านต้องการจะเปลี่ยนหรือไม่",
    "투표가 수정되었습니다." : "แก้ไขแล้ว",
    "투표를 삭제하시겠습니까?" : "ท่านต้องการจะลบโพลหรือไม่",
    "해당 투표 항목을 삭제하시겠습니까?" : "ท่านต้องการจะลบตัวเลือกนี้หรือไม่",
    "투표하기" : "โหวต",
    "결과 미리보기" : "ดูผล",
    "다시 투표하기" : "	โหวตอีกครั้ง",
    "전체 참여자" : "ผู้เข้าร่วม",
    "명" : "",
    "투표하러 가기" : "เข้าร่วมโหวต",
    "현재시간 이후를 선택해주세요." : "กรุณาเลือกเวลาหลังจากเวลาปัจจุบัน",
    "투표 종료일을 3개월 이내로 선택해주세요." : "กรุณาเลือกวันสิ้นสุดเวลาโหวตภายใน 3 เดือนหลังจากปัจจุบัน",
    "투표가 등록되었습니다." : "ท่านได้ลงทะเบียนการโหวตแล้ว",
    "투표를 등록한 유저가 삭제한 투표입니다." : "การโหวตถูกลบโดยผู้ตั้งการโหวต",
    "다른 투표에 참여해주세요." : "กรุณาเข้าร่วมการโหวตอื่น",
    "투표에 참여 완료되었습니다." : "ท่านได้ทำการโหวตเรียบร้อย",
    "투표 종료" : "สิ้นสุดการโหวต",
    "투표를 종료하시겠습니까?" : "ท่านต้องการจะยุติการโหวตหรือไม่",
    "항목 추가" : "เพิ่มไอเทม",
    "취소" : "ยกเลิก",
    "시" : "",
    "분" : " น.",
    "이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다.": "เมื่อทำการอัพโหลดรูปสำหรับการโหวตแบบ 1:1 ท่านต้องอัพโหลดรูปให้กับตัวเลือกทั้งคู่จึงจะสามารถดำเนินการต่อได้",
    "무승부" : "ผูก",
    "무승부 항목 추가" : "เพิ่มการจับสลาก",
}